<template>
  <div class="v-input-range">
    <v-input
      v-model="inputValue[0]"
      @keyEnter="handlerKeyEnter"
      @blur="handlerBlur" />
    <span class="middle-text">{{ text }}</span>
    <v-input 
      v-model="inputValue[1]"
      @keyEnter="handlerKeyEnter"
      @blur="handlerBlur" />
  </div>
</template>
<script>
export default {
  name: 'VInputRange',
  props: {
    text: {
      type: String,
      default: 'to'
    },
    value: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      inputValue: []    
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val instanceof Array) {
          const valStr = JSON.stringify(val)
          const inputStr = JSON.stringify(this.inputValue)
          if(valStr != inputStr) {
            this.inputValue = JSON.parse(valStr)
          }
        }
      }
    },
    inputValue: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handlerBlur() {
      this.$emit('blur')
    },
    handlerKeyEnter() {
      this.$emit('keyEnter')
    }
  }
}
</script>
<style lang="scss" scoped>
.v-input-range {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    .el-input {
        flex: 1;
       /deep/ .el-input__inner {
            border: 0;  
        }
    }
    .middle-text {
        display: inline-block;
        padding: 0 10px;
        color: #909399;
        font-size: 13px;
    }
}
</style>